import { useQueryClient } from "@tanstack/react-query";
import { FilterCriteria } from "@bagel-web/components";
import type { CommonProject } from "../types/Project";
import { projectQueries } from "../queries";
import AsyncOptionsSelect from "../select/AsyncOptionsSelect";
import { PaginatedSearch } from "../util/pagination";
import { Page } from "../types";

export type fetchProjectsCallback = (
  paginatedSearch: PaginatedSearch<{ name?: string; organization?: string }>
) => Promise<Page<CommonProject>>;

export type ProjectSelectProps = {
  value: string | null;
  fetchProjects: (
    filters: PaginatedSearch<{
      organization?: string;
      includeArchived: boolean;
    }>
  ) => Promise<Page<CommonProject>>;
  onChange: (e: { target: { value: string } }) => void;
  autoFocus?: boolean;
  organization?: string;
  placeholder?: string;
  disabled?: boolean;
  localCriteria?: FilterCriteria<string>;
};

const ProjectSelect = ({
  value,
  onChange,
  organization,
  fetchProjects,
  placeholder,
  disabled = false,
}: ProjectSelectProps) => {
  const queryClient = useQueryClient();

  const fetchOptions = async () => {
    const projects = await queryClient.fetchQuery({
      queryKey: projectQueries.list({
        startsAfter: null,
        includeArchived: false,
        organization,
      }),
      queryFn: () =>
        fetchProjects({
          startsAfter: null,
          includeArchived: false,
          organization,
        }),
    });
    return projects.items.map((project) => ({
      value: project.id,
      label: project.name,
    }));
  };

  return (
    <AsyncOptionsSelect
      value={value}
      fetchOptions={fetchOptions}
      onChange={onChange}
      placeholder={placeholder}
      disabled={disabled}
      isClearable
    />
  );
};

export default ProjectSelect;
